import React, {useState} from 'react';
import { Link, useLocation, Outlet} from 'react-router-dom';
import { useAccount } from "wagmi";
import { useWeb3ModalState } from "@web3modal/wagmi/react";
import useWindowSize from '../../hooks/useWindowSize';
import IconClose from '../common/asset/images/icon-close.svg';

const IconAsk = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M21.17 8.83003V15.67C21.17 16.79 20.57 17.83 19.6 18.4L13.66 21.83C12.69 22.39 11.49 22.39 10.51 21.83L4.57001 18.4C3.60001 17.84 3 16.8 3 15.67V8.83003C3 7.71003 3.60001 6.66999 4.57001 6.09999L10.51 2.67C11.48 2.11 12.68 2.11 13.66 2.67L19.6 6.09999C20.57 6.66999 21.17 7.70003 21.17 8.83003Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.159 7.5C12.753 7.5 13.2705 7.5945 13.7115 7.7835C14.1525 7.9725 14.4945 8.2425 14.7375 8.5935C14.9895 8.9445 15.1155 9.363 15.1155 9.849C15.1155 10.371 14.9985 10.8075 14.7645 11.1585C14.5395 11.5005 14.2335 11.7615 13.8465 11.9415C13.4685 12.1215 13.0455 12.2385 12.5775 12.2925V13.737H11.457V11.712C12.114 11.613 12.6225 11.4915 12.9825 11.3475C13.3515 11.2035 13.608 11.0235 13.752 10.8075C13.905 10.5915 13.9815 10.326 13.9815 10.011C13.9815 9.696 13.9095 9.426 13.7655 9.201C13.6305 8.976 13.4235 8.805 13.1445 8.688C12.8655 8.571 12.51 8.5125 12.078 8.5125C11.484 8.5125 10.998 8.679 10.62 9.012C10.251 9.336 10.0305 9.7815 9.9585 10.3485L9 9.795C9.099 9.336 9.288 8.9355 9.567 8.5935C9.855 8.2425 10.215 7.9725 10.647 7.7835C11.088 7.5945 11.592 7.5 12.159 7.5ZM11.997 14.925C12.258 14.925 12.4695 15.006 12.6315 15.168C12.7935 15.33 12.8745 15.5415 12.8745 15.8025C12.8745 16.0635 12.7935 16.275 12.6315 16.437C12.4695 16.599 12.258 16.68 11.997 16.68C11.736 16.68 11.5245 16.599 11.3625 16.437C11.2005 16.275 11.1195 16.0635 11.1195 15.8025C11.1195 15.5415 11.2005 15.33 11.3625 15.168C11.5245 15.006 11.736 14.925 11.997 14.925Z" />
    </svg>
);

const dataTabs = [
    {to: '/launchpad/upcoming', title: 'Upcoming', loginRequired: false},
    {to: '/launchpad/opening', title: 'Opening', loginRequired: false},
    {to: '/launchpad/completed', title: 'Completed', loginRequired: false},
    {to: '/launchpad/joined', title: 'Joined', loginRequired: true},
    {to: '/launchpad/claimable', title: 'Claimable', ask: IconAsk(), loginRequired: true},
];

const LaunchPad = () => {
    const [isOpenTab, setIsOpenTab] = useState(false);
    let location = useLocation();
    const size = useWindowSize();
    const sizeTablet = 767;
    let myPathname = location.pathname;
    const sep = /\//;
    let isPathname = myPathname.split(sep);

    const { address } = useAccount();
    const { selectedNetworkId } = useWeb3ModalState()
    const chainId = selectedNetworkId
    
    const elmMenuTabs = dataTabs.map((item,key) => {
        let myTab = item.to;
        let isTabName = myTab.split(sep);

        if(item.loginRequired) {
            return(
                <>
                {address && <li key={key} className={isPathname[2]===isTabName[2] ? 'is-active' : ''}>
                    <Link onClick={() => setIsOpenTab(false)} to={item.to}>{item.title}</Link>
                    {item.ask && <div className="c-tabs__ask">
                        {item.ask}
                        <p>
                            Including all the pools you have joined that:<br />
                            - Will have vesting schedule during the next 30 days.<br/>
                            - Have IDO tokens you forgot to claim.
                        </p>
                    </div>}
                </li>}
                </>
            );
        }
        else {
            return(
                <li key={key} className={isPathname[2]===isTabName[2] ? 'is-active' : ''}>
                    <Link onClick={() => setIsOpenTab(false)} to={item.to}>{item.title}</Link>
                    {item.ask && <div className="c-tabs__ask">
                        {item.ask}
                        <p>
                            Including all the pools you have joined that:<br />
                            - Will have vesting schedule during the next 30 days.<br/>
                            - Have IDO tokens you forgot to claim.
                        </p>
                    </div>}
                </li>
            );
        }
    });
    return(
        <div className="p-launchpad">
            {isOpenTab ? <div className="c-bgSP"></div> : ''}
            <div className="c-tabs">
                {size.width <= sizeTablet ? <div className="c-tabs__navSP" onClick={() => setIsOpenTab(true)}>{isPathname[2]}</div> : ''}
                <ul className={`c-tabs__nav ${isOpenTab ? 'is-open' : ''}`}>
                    {size.width <= sizeTablet ? <li className="is-close">Status<span onClick={() => setIsOpenTab(false)}><img src={IconClose} alt="Close" /></span></li> : ''}
                    {elmMenuTabs}
                </ul>
                <div className="c-tabs__content">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default LaunchPad;